var map = {
	"./tasks/analysis_data_entry/dealers_sales/routes.children.js": 7061,
	"./tasks/analysis_data_entry/dealers_sales_return/routes.children.js": 6307,
	"./tasks/analysis_data_entry/dealers_stock/routes.children.js": 6593,
	"./tasks/analysis_data_entry/dealers_targets/routes.children.js": 6578,
	"./tasks/analysis_data_entry/distributors_plan_3yrs/routes.children.js": 5800,
	"./tasks/analysis_data_entry/distributors_sales/routes.children.js": 1335,
	"./tasks/analysis_data_entry/distributors_sales_return/routes.children.js": 1651,
	"./tasks/analysis_data_entry/distributors_stock/routes.children.js": 8995,
	"./tasks/analysis_data_entry/distributors_targets/routes.children.js": 7339,
	"./tasks/analysis_data_entry/market_size_setup/routes.children.js": 889,
	"./tasks/analysis_data_entry/market_size_setup_territory/routes.children.js": 7950,
	"./tasks/analysis_data_entry/six_crop_sales_planning/routes.children.js": 4382,
	"./tasks/analysis_data_entry/territories_plan_3yrs/routes.children.js": 7064,
	"./tasks/analysis_reports/dealer_sales_target/routes.children.js": 2361,
	"./tasks/analysis_reports/dealers_sales_entry/routes.children.js": 6071,
	"./tasks/analysis_reports/dealers_sales_entry_details/routes.children.js": 5296,
	"./tasks/analysis_reports/distributors_plan_3yrs/routes.children.js": 5373,
	"./tasks/analysis_reports/distributors_stock/routes.children.js": 8575,
	"./tasks/analysis_reports/distributors_stock_summary/routes.children.js": 905,
	"./tasks/analysis_reports/incentive/routes.children.js": 8134,
	"./tasks/analysis_reports/incentive_back/routes.children.js": 9237,
	"./tasks/analysis_reports/incentive_summary/routes.children.js": 156,
	"./tasks/analysis_reports/market_size/routes.children.js": 1185,
	"./tasks/analysis_reports/sales/routes.children.js": 8274,
	"./tasks/analysis_reports/sales_target/routes.children.js": 5205,
	"./tasks/analysis_reports/type_months/routes.children.js": 6207,
	"./tasks/product_bonus_dealer/bonus_setup/routes.children.js": 1038,
	"./tasks/product_presentation_data_entry/product_information/routes.children.js": 252,
	"./tasks/setup/analysis_year/routes.children.js": 2949,
	"./tasks/setup/competitors/routes.children.js": 9859,
	"./tasks/setup/crop-types/routes.children.js": 9511,
	"./tasks/setup/crops/routes.children.js": 5408,
	"./tasks/setup/dealer_types/routes.children.js": 7765,
	"./tasks/setup/dealers/routes.children.js": 1013,
	"./tasks/setup/distributor/routes.children.js": 7074,
	"./tasks/setup/incentive_configurations/routes.children.js": 3162,
	"./tasks/setup/incentive_slabs/routes.children.js": 6571,
	"./tasks/setup/incentive_varieties/routes.children.js": 8216,
	"./tasks/setup/location_areas/routes.children.js": 2023,
	"./tasks/setup/location_districts/routes.children.js": 5880,
	"./tasks/setup/location_divisions/routes.children.js": 9203,
	"./tasks/setup/location_parts/routes.children.js": 2062,
	"./tasks/setup/location_territories/routes.children.js": 8356,
	"./tasks/setup/location_unions/routes.children.js": 4751,
	"./tasks/setup/location_upazilas/routes.children.js": 2379,
	"./tasks/setup/pack_size/routes.children.js": 8334,
	"./tasks/setup/principals/routes.children.js": 6605,
	"./tasks/setup/seasons/routes.children.js": 566,
	"./tasks/setup/type_months/routes.children.js": 2089,
	"./tasks/setup/type_months_color/routes.children.js": 9685,
	"./tasks/setup/varieties/routes.children.js": 493,
	"./tasks/setup/variety_sub_types/routes.children.js": 3294,
	"./tasks/system/configurations/routes.children.js": 9600,
	"./tasks/system/module-tasks/routes.children.js": 689,
	"./tasks/system/user-groups/routes.children.js": 6228,
	"./tasks/system/user-types/routes.children.js": 5860,
	"./tasks/users/routes.children.js": 7098,
	"./tasks/variety-configuration/delivery/routes.children.js": 9325,
	"./tasks/variety-configuration/selection/routes.children.js": 592,
	"./tasks/variety-configuration/sowing/routes.children.js": 3805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9196;